import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms12x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms12x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_sql_statement: (typeof searchParams.syncond.code !== 'undefined' ? searchParams.syncond.code : '')
      }
    }
    return instance().get(endpoint + '/hrms12x/index', { params: sendParams })
  },
  postSendmail (saveParams) {
    if (isMock) return generator(mocker.send())
    saveParams.p_reciver = JSON.stringify(saveParams.p_reciver)
    return instance().post(endpoint + '/hrms12x/sendmail', saveParams)
  },
  getListFields () {
    if (isMock) return generator(mocker.listFields())
    return instance().get(endpoint + '/hrms12x/listFields')
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms12x/index.js